import * as React from "react";
const SvgZendeskWhite = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...props },
    React.createElement("path", { fill: "#fff", d: "M13 4v12L23 4zM6 9a5 5 0 0 1-5-5h10a5 5 0 0 1-5 5M18 15a5 5 0 0 1 5 5H13a5 5 0 0 1 5-5M11 8v12H1z" })));
export default SvgZendeskWhite;
//# sourceMappingURL=ZendeskWhite.js.map